import { render, staticRenderFns } from "./SchoolSelector.vue?vue&type=template&id=7a8569e3&scoped=true&"
import script from "./SchoolSelector.vue?vue&type=script&lang=js&"
export * from "./SchoolSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8569e3",
  null
  
)

export default component.exports